import httpClient from '@/services/httpClient'
import { GeneralThemeAndControls } from './types'

export default {
  getClinicColorsById(clinicId: number): Promise<GeneralThemeAndControls> {
    return httpClient
      .get(`/clinica/config/tema/${clinicId}`)
      .then(res => res.data.object)
      .catch(() => {
        return null
      })
  },
  getClinicColorsByUniqueCode(
    uniqueCode: string,
  ): Promise<GeneralThemeAndControls> {
    return httpClient
      .get(`/clinica/config/tema/codigo_unico/${uniqueCode}`)
      .then(res => res.data.object)
      .catch(() => {
        return null
      })
  },
}
